import React from 'react';
import PageHeader from 'components/common/PageHeader';
import { Card } from 'react-bootstrap';
import { getToastList } from 'y4/Utils';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const ToastList = () => {
  const list = getToastList();
  const ts = list.toReversed();
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        title={t('Notification List')}
        description={t('Below is the notification that has popped up')}
        className="mb-3"
      />
      <Card className="mb-3">
        <Card.Body>
          {ts.map((t, index) => (
            <div key={index}>
              <p
                className={classNames('fs--1 mb-0', {
                  'text-danger': t.type == 'error',
                  'text-success': t.type == 'success',
                  'text-info': t.type == 'info',
                  'text-warning': t.type == 'warn'
                })}
              >
                {t.content}
              </p>
              <p className="fs--2">{t.time}</p>
              {!(index === ts.length - 1) && <hr className="my-3" />}
            </div>
          ))}
        </Card.Body>
        <Card.Footer></Card.Footer>
      </Card>
    </>
  );
};

export default ToastList;
